import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// ฟังก์ชันแปลงตัวเลขเป็นคำอ่านภาษาไทย (บาทถ้วน)
const ThaiBahtText = (amount) => {
  if (amount === 0) return "ศูนย์บาทถ้วน";
  const text = amount.toString();
  const t = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];
  const n = [
    "",
    "หนึ่ง",
    "สอง",
    "สาม",
    "สี่",
    "ห้า",
    "หก",
    "เจ็ด",
    "แปด",
    "เก้า",
  ];
  let res = "";
  for (let i = 0; i < text.length; i++) {
    const digit = parseInt(text[i]);
    const pos = text.length - i - 1;
    if (digit !== 0) {
      if (pos % 6 === 1 && digit === 2) res += "ยี่";
      else if (pos % 6 === 1 && digit === 1) res += "";
      else if (
        pos % 6 === 0 &&
        digit === 1 &&
        text.length > 1 &&
        text[i - 1] !== "0"
      )
        res += "เอ็ด";
      else res += n[digit];
      res += t[pos % 6];
    }
    if (pos > 0 && pos % 6 === 0) res += "ล้าน";
  }
  return res + "บาทถ้วน";
};

// เปลี่ยนเป็น Async Function ทั่วไป (ไม่ต้อง return HTML/JSX แล้ว)
const ExportExcelForPayment = async (rawData) => {
  try {
    const workbook = new ExcelJS.Workbook();
    console.log("ข้อมูลที่ส่งเข้าทำ Excel:", rawData);

    // ป้องกัน Error กรณีไม่มีข้อมูล items
    const items = rawData?.items || [];

    // ==========================================
    // คำนวณยอดรวมจากข้อมูล JSON
    // ==========================================
    let totalOpFee = 0;
    let totalTr14 = 0;
    let totalFam = 0;

    items.forEach((item) => {
      totalOpFee += Number(item.operationFee || 0);
      totalTr14 += Number(item.tr14 || 0);
      totalFam += Number(item.familyRegistration || 0);
    });

    const grandTotal = totalOpFee + totalTr14 + totalFam;
    const currentDate = new Date().toISOString().split("T")[0];

    // ==========================================
    // Sheet 1: ใบสำคัญรับเงิน
    // ==========================================
    const sheet1 = workbook.addWorksheet("ใบสำคัญรับเงิน (ลิสซิ่ง)");

    sheet1.columns = Array(10).fill({ width: 15 });

    sheet1.addRow([
      "ใช้ในกรณี ผู้รับเงินไม่สามารถออกใบเสร็จรับเงินให้ได้ แต่ยินยอมที่จะลงลายมือชื่อในช่องผู้รับเงิน",
    ]);
    sheet1.addRow([]);
    sheet1.addRow(["", "", "ใบสำคัญรับเงิน"]);
    sheet1.addRow([]);
    sheet1.addRow(["", "", "", "", "", "", "", "", "เลขที่", ""]);
    sheet1.addRow(["", "", "", "", "", "", "", "", "วันที่", currentDate]);
    sheet1.addRow([]);
    sheet1.addRow(["", "", "", "ข้าพเจ้า", "นายธนกฤต มานนท์"]);
    sheet1.addRow([
      "",
      "",
      "เลขประจำตัวผู้เสียภาษี",
      "",
      "1409900361029",
      "",
      "อยู่ที่บ้านเลขที่",
      "40",
      "หมู่",
      "2",
    ]);
    sheet1.addRow([
      "",
      "",
      "ถนน",
      "",
      "แขวง/ตำบล",
      "ศิลา",
      "เขต/อำเภอ",
      "เมืองขอนแก่น",
      "จังหวัด",
      "ขอนแก่น",
    ]);
    sheet1.addRow([]);
    sheet1.addRow([
      "",
      "",
      "",
      "ได้รับเงินจาก",
      "บริษัท วัน ลิสซิ่ง จำกัด",
      "",
      "",
      "ดังรายการต่อไปนี้",
    ]);
    sheet1.addRow([]);
    sheet1.addRow(["", "", "รายการ", "", "", "", "", "", "จำนวนเงิน"]);
    sheet1.addRow([
      "",
      "",
      "ค่าดำเนินการสืบทรัพย์",
      "",
      "",
      "",
      "",
      "",
      totalOpFee,
    ]);
    sheet1.addRow(["", "", "ค่าคัด ทร.14", "", "", "", "", "", totalTr14]);
    sheet1.addRow([
      "",
      "",
      "ค่าคัดทะเบียนครอบครัว",
      "",
      "",
      "",
      "",
      "",
      totalFam,
    ]);

    for (let i = 0; i < 10; i++) sheet1.addRow([]);

    sheet1.addRow([
      "",
      "",
      `( ${ThaiBahtText(grandTotal)} )`,
      "",
      "",
      "",
      "",
      "รวมเป็นเงิน (บาท)",
      grandTotal,
    ]);
    sheet1.addRow([]);
    sheet1.addRow([]);
    sheet1.addRow([
      "",
      "",
      "ลงชื่อ",
      "",
      "",
      "ผู้รับเงิน",
      "ลงชื่อ",
      "",
      "",
      "ผู้จ่ายเงิน",
    ]);
    sheet1.addRow([]);
    sheet1.addRow([
      "",
      "",
      "หมายเหตุ :  แนบสำเนาบัตรประจำตัวประชาชนผู้รับเงิน",
    ]);

    // ==========================================
    // Sheet 2: ทนาย
    // ==========================================
    const sheet2 = workbook.addWorksheet("ทนาย");

    sheet2.addRow([
      "ค่าดำเนินการทนาย",
      "ทร.14",
      "ทะเบียนครอบครัว",
      "รวม",
      "ค่าธรรมเนียมอื่น",
    ]);

    items.forEach((item) => {
      const op = Number(item.operationFee || 0);
      const tr14 = Number(item.tr14 || 0);
      const fam = Number(item.familyRegistration || 0);
      const total = op + tr14 + fam;
      const otherFee = tr14 + fam;

      sheet2.addRow([op, tr14, fam, total, otherFee]);
    });

    const lastDataRow = items.length > 0 ? items.length + 1 : 2;
    const sumRowNumber = lastDataRow + 1;

    sheet2.addRow({
      1: { formula: `SUM(A2:A${lastDataRow})` },
      2: { formula: `SUM(B2:B${lastDataRow})` },
      3: { formula: `SUM(C2:C${lastDataRow})` },
      4: { formula: `SUM(D2:D${lastDataRow})` },
      5: { formula: `SUM(E2:E${lastDataRow})` },
    });

    sheet2.getRow(sumRowNumber).font = { bold: true };

    // ==========================================
    // สร้างและดาวน์โหลดไฟล์
    // ==========================================
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // ตั้งชื่อไฟล์โดยเอา TEMPBILL มาแนบด้วย (ถ้ามี)
    const billName = rawData?.TEMPBILL || "Unknown";
    saveAs(blob, `ใบรับรองแทนใบเสร็จ_${billName}_${currentDate}.xlsx`);
  } catch (error) {
    console.error("เกิดข้อผิดพลาดในการสร้าง Excel:", error);
  }
};

export default ExportExcelForPayment;
